import type { InjectionKey } from 'vue'
import type { ShowDeactivateAgencyModalParams } from '../modals/AgencyModalDeactivate.vue'
import type { ShowChangeContactInfoModalParams } from '../modals/AgencyModalChangeContactInfo.vue'
import type { ShowChangeAgencyNameModalParams } from '../modals/AgencyModalChangeName.vue'
import type { ShowMoveAgencyModalParams } from '../modals/AgencyModalMove.vue'
import type { ShowLinkToOtherCompanyModalParams } from '../modals/AgencyModalLinkToOtherCompany.vue'
import type { ShowReactivateAgencyModalParams } from '../modals/AgencyModalReactivate.vue'

export interface AgencyModalsProviderContext {
  showAgencyDeactivateModal: (params: ShowDeactivateAgencyModalParams) => void
  showChangeAgencyContactInfoModal: (
    params: ShowChangeContactInfoModalParams
  ) => void
  showChangeAgencyNameModal: (params: ShowChangeAgencyNameModalParams) => void
  showMoveAgencyModal: (params: ShowMoveAgencyModalParams) => void
  showLinkToOtherCompanyModal: (
    params: ShowLinkToOtherCompanyModalParams
  ) => void
  showReactivateAgencyModal: (params: ShowReactivateAgencyModalParams) => void
}

export const agencyModalsKey = Symbol(
  'agencyProviderKey'
) as InjectionKey<AgencyModalsProviderContext>
